import { Slideover } from 'tailwindcss-stimulus-components'

export default class extends Slideover {
  declare readonly dialogTarget: HTMLDialogElement
  declare readonly element: HTMLElement

  connect (): void {
    super.connect()
    this.assignAccessibleName()
  }

  backdropClose (event: any): void {
    if (event.target.nodeName === 'DIALOG' && event.target === this.dialogTarget) {
      super.backdropClose(event)
      this.clearSlideoverState()
      this.reloadIfRequested()
    }
  }

  close (): void {
    super.close()
    this.clearSlideoverState()
    this.reloadIfRequested()
  }

  // Empty #dynamic-slideover so cached snapshots don't auto-reopen it.
  beforeCache (): void {
    super.beforeCache()
    const frame = this.element.closest('#dynamic-slideover')
    if (frame !== null) frame.innerHTML = ''
  }

  private clearSlideoverState (): void {
    const dialogFlash = this.dialogTarget.querySelector<HTMLElement>('#dialog-flash')
    if (dialogFlash != null) dialogFlash.innerHTML = ''

    const bulkEditErrors = this.dialogTarget.querySelector<HTMLElement>('#bulk-edit-evidences-errors')
    if (bulkEditErrors != null) bulkEditErrors.innerHTML = ''
  }

  private reloadIfRequested (): void {
    const shouldReload = this.dialogTarget?.dataset?.reloadPage === 'true'

    if (shouldReload) {
      requestAnimationFrame(() => { window.location.reload() })
    }
  }

  private assignAccessibleName (): void {
    if (this.dialogTarget.hasAttribute('aria-labelledby') || this.dialogTarget.hasAttribute('aria-label')) return

    const titleContainer = this.dialogTarget.querySelector<HTMLElement>('.slideover-header-title') ??
      this.dialogTarget.querySelector<HTMLElement>('h2')
    if (titleContainer === null) return

    if (titleContainer.id === '') {
      titleContainer.id = `slideover-title-${Math.random().toString(36).slice(2, 10)}`
    }

    this.dialogTarget.setAttribute('aria-labelledby', titleContainer.id)
  }
}
